import {
  getMyPointsList,
  getMyPointsRecord,
  addGivePoints,
  getGivePoints,
  fetchGiveReq,
  getPointsRule
} from "@/api/shop/shopPoints";

export default {
  namespaced: true,
  state: {
    list: []
  },
  actions: {
    async getMyPointsList(context, params) {
      const { data } = await getMyPointsList(params);
      return data;
    },
    async getMyPointsRecord(context, params) {
      const { data } = await getMyPointsRecord(params);
      return data;
    },
    async getPointsRule(context, params) {
      const { data } = await getPointsRule(params);
      return data;
    },
    async addGivePoints(context, params) {
      const data = await addGivePoints(params);
      return data;
    },
    async getGivePoints(context, params) {
      const data = await getGivePoints(params);
      return data;
    },
    async fetchGiveReq(context, params) {
      const data = await fetchGiveReq(params);
      return data;
    }
  }
};
